// Armadilo — page.aerionb1g1 template
// Shared JS for all sections rendered on this template.
// Loaded only when `template contains 'aerionb1g1'` (see layout/theme.liquid).

class AerionCountdown extends HTMLElement {
  #intervalId = null;

  connectedCallback() {
    const endDate = this.dataset.endDate;
    const seconds = parseInt(this.dataset.seconds, 10);

    this.target = endDate
      ? new Date(`${endDate}T00:00:00`)
      : new Date(Date.now() + (Number.isNaN(seconds) ? 0 : seconds) * 1000);

    this.daysEl = this.querySelector('[data-unit="days"]');
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');

    this.#update();
    this.#intervalId = setInterval(this.#update.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#intervalId);
  }

  #update() {
    const remaining = Math.max(0, Math.floor((this.target - Date.now()) / 1000));

    if (remaining <= 0) {
      clearInterval(this.#intervalId);
      this.hidden = true;
      return;
    }

    const days = Math.floor(remaining / 86400);
    const hours = Math.floor((remaining % 86400) / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }
}

customElements.define('aerionb1g1-countdown', AerionCountdown);

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-aerionb1g1-dialog-open]');

  if (opener) {
    const dialog = document.getElementById(opener.dataset.aerionb1g1DialogOpen);
    dialog?.showModal();
    return;
  }

  const closer = event.target.closest('[data-aerionb1g1-dialog-close]');

  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }

  if (event.target.matches('.aerionb1g1-size-chart-dialog[open]')) {
    event.target.close();
    return;
  }

  for (const dropdown of document.querySelectorAll('.aerionb1g1-size-select[open]')) {
    if (!dropdown.contains(event.target)) {
      dropdown.open = false;
    }
  }
});

document.addEventListener('change', (event) => {
  const sizeInput = event.target.closest('.aerionb1g1-size-select input[type="radio"]');

  if (!sizeInput) return;

  const dropdown = sizeInput.closest('.aerionb1g1-size-select');
  dropdown.open = false;

  const sizeValue = sizeInput.parentElement.querySelector('[data-aerionb1g1-size-value]');
  const label = dropdown.querySelector('[data-aerionb1g1-size-label]');

  if (sizeValue && label) {
    label.textContent = sizeValue.textContent;
  }
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-aerionb1g1-scroll-to]');

  if (!link) return;

  const targetId = link.getAttribute('href');

  if (!targetId || !targetId.startsWith('#')) return;

  const target = document.querySelector(targetId);

  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
